import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { MutationCache, QueryCache, QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { BrowserRouter } from 'react-router';
import { App } from './App';
import { AuthProvider } from './lib/auth';
import { TipProvider } from './components/Tip';
import { I18nProvider } from './lib/i18n';
import { PlayerProvider } from './components/Player';
import { ErroDaTela } from './components/ErroDaTela';
import { FaixaDeAmbiente } from './components/FaixaDeAmbiente';
import { AvisosDeErro } from './components/AvisosDeErro';
import { avisar, deveAvisar, textoDoErro } from './lib/aviso-de-erro';
import { instalarRastreioDoNavegador, relatarFalhaDeConsulta } from './lib/rastreio';

import '@fontsource-variable/plus-jakarta-sans';
import './styles/tokens.css';
import './styles/base.css';
import './styles/shell.css';

const client = new QueryClient({
  queryCache: new QueryCache({ onError: relatarFalhaDeConsulta }),
  // Relatar vai para o rastreio do servidor; avisar e so para a tela. Sao destinos
  // diferentes do mesmo erro, entao nada e registrado duas vezes.
  mutationCache: new MutationCache({
    onError: (err, _vars, _ctx, mutation) => {
      relatarFalhaDeConsulta(err);
      if (deveAvisar(mutation)) avisar(textoDoErro(err));
    },
  }),
  defaultOptions: {
    queries: {
      staleTime: 30_000,
      refetchOnWindowFocus: false,
      retry: 1,
    },
  },
});

instalarRastreioDoNavegador();

const container = document.getElementById('root');
if (container === null) throw new Error('#root nao existe no index.html');

createRoot(container).render(
  <StrictMode>
    <ErroDaTela>
      <I18nProvider>
        <TipProvider>
          <QueryClientProvider client={client}>
            <BrowserRouter>
              <FaixaDeAmbiente />
              <AuthProvider>
                <PlayerProvider>
                  <App />
                  <AvisosDeErro />
                </PlayerProvider>
              </AuthProvider>
            </BrowserRouter>
          </QueryClientProvider>
        </TipProvider>
      </I18nProvider>
    </ErroDaTela>
  </StrictMode>,
);
